import styled from "styled-components";
import { colors } from "@/theme";
import { TextField } from "@mui/material";

export const CrudGridContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CrudGridHeader = styled.div`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 18px;
  font-style: normal;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 18px;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding-bottom: 12px;
`;
